// /pages/blog/index.page.route.js
// Environment: server

// Route String
export default '/blog'
